import { render, staticRenderFns } from "./ResponsiveImage.vue?vue&type=template&id=1f0c17d8&scoped=true"
import script from "./ResponsiveImage.vue?vue&type=script&lang=js"
export * from "./ResponsiveImage.vue?vue&type=script&lang=js"
import style0 from "./ResponsiveImage.vue?vue&type=style&index=0&id=1f0c17d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0c17d8",
  null
  
)

export default component.exports